import React from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment';
import therapy_icon from '../styles/img/footer/TH_logo_light.png'

export default class Footer extends React.Component {

  render() {
    return (
      <footer className="main-footer">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="mobile">
                <ul className="social">
                  <li><a href="https://www.facebook.com/TherapyAcademy/" target="_blank" className="fa fa-facebook" aria-hidden="true"/></li>
                  <li><a href="https://twitter.com/academy_therapy" target="_blank" className="fa fa-twitter" aria-hidden="true"/></li>
                  <li><a href="https://www.linkedin.com/company/therapy-academy/" target="_blank" className="fa fa-linkedin"/></li>
                </ul>
              </div>
              <div className="row">
                <div className="col-6">
                  <p className="copy">{`© Therapy Academy ${moment().format('YYYY')}. All rights reserved.`}</p>
                </div>
                <div className="col-6">
                  <p className="partner">Have you signed up to <a href="https://www.therapyhub.ie/" target="_blank"><img className="footer_icon" src={therapy_icon}/></a> ?</p>
                </div>
                <ul className="social">
                  <li>
                    <Link to="/termsofconditions" className="partner">
                      Terms of Service
                    </Link>
                  </li>
                  <li>
                    <Link to="/providerterms" className="partner">
                      Provider Terms
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacypolicy" className="partner">
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/cookiespolicy" className="partner">
                      Cookies Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/subprocessors" className="partner">
                      Sub-Processors
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.jsx